<template>
  <div class="gg-wrapper">
    <div class="gg-title box">
      <div>社区公告</div>
    </div>
    <div class="gg-card">
      <div class="gg-card-title box">
        <div>{{gonggao.title}}</div>
      </div>
      <div class="gg-card-title-min box">
        <div>{{gonggao.name}}&nbsp;&nbsp;{{gonggao.time}}</div>
      </div>
      <div class="gg-card-info" id="context">
        <div v-if="scrollHeight<600" v-html="gonggao" class="gonggao-context" ></div>
        
        <y-scroll v-if="gonggao && scrollHeight >=600" :contentArr="num" :height="640" :lineNum="2" :width="1665" :totalTime="totalTime" :totalHeight="scrollHeight" >
          <div slot="scroll" slot-scope="props">
            <div v-html="gonggao.content" class="gonggao-context" ></div>
          </div>
        </y-scroll>
      </div>
    </div>
  </div>
</template>

<script>
  var that
  import yScroll from '../../components/yScrollYunsu'
  export default {
    inject:['reload'],
    components: {
      yScroll
    },
    data () {
      return {
        Height:window.document.body.offsetHeight-60,
        Width:window.document.body.offsetWidth,
        num:[1],
        gonggao:'',
        scrollHeight:'',
        totalTime: ''
      }

    },
    watch:{
      gonggao (newValue,oldValue) {
        console.log('有内容了')
        var context = document.getElementById("context");
        this.scrollHeight = context.clientHeight - 40
        this.totalTime = this.scrollHeight/30
        console.log(this.scrollHeight)

      }
    },
    computed :{

    },
    mounted: function () {
      that = this
      window.addEventListener('resize', this.handleResize)
      this.Height = window.document.body.offsetHeight-60
      this.Width = window.document.body.offsetWidth
      if (this.Height < 788) {
        this.Height = 788
      }
      this.getGonggao()
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    methods:{
      handleResize (event) {
        this.Height = document.documentElement.clientHeight -60
        this.Width = window.document.body.offsetWidth
      },
      getGonggao () {
        var url = this.urlobj.getTvGonggao
        this.$get(url).then(res => {
          that.gonggao = {
            content:res.rows[0].context,
            title:res.rows[0].title,
            name:res.rows[0].communityName,
            time:res.rows[0].sendDate.replace(/\.0/g,'')
          }
        })
      }
    },
  }
</script>

<style scoped>
  .gonggao-context >>> p{
    display: flex !important;
    flex-direction: column !important;
  }
  .gonggao-context >>> img{
    height: 440px !important;
    margin: auto !important;
  }




  .gg-wrapper{
    width: 100%;
    height: 100%;
    background-image: url("../../assets/staticsPic/ggbi.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .gg-title{
    height:11.76%;
    font-size: 40px;
    justify-content: center;
    align-items: center;
  }
  .gg-card{
    background-color: rgba(255,255,255,0.7);
    width: 90.9%;
    height:78.43%;
    margin:0 auto;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 2px #b3ccd3;
    padding-bottom:2%;
  }
  .gg-card-title{
    height: 13.125%;
    width: 100%;
    font-size: 34px;
    padding: 2.22% 2% 1.66% ;
    justify-content: center;
    align-items: center;
    text-align: center
  }
  .gg-card-title-min{
    height: 3.125%;
    width: 100%;
    font-size: 24px;
    justify-content: center;
    align-items: center;
    color:#999
  }
  .gg-card-info{
    /*height: 83.75%;*/
    height: 640px;
    width: 100%;
    padding: 40px ;
    overflow: hidden;
  }
  .scroll-wrapper{
    width: 100%;/*1240px*/
    height: 100%;
    /*padding:2.222%*/
  }
  .scroll-word{
    height: 13.559%;
    width: 100%;
    font-size: 24px;
    text-align: center;
    line-height: 1.4;
    color:#444
  }
  .scroll-img-wrapper{
    height: 72.88%;/*59.32*/
    width:68.965%;
    padding:3.448% 0;
    margin: 0 auto;
  }

</style>
